class DocumentType {
    id = null;
    name = '';
    document_category_id = 1;
    notify_before = 0;
    active = true;
    notify = true;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default DocumentType;
